import customAxios from "./axiosConfig";
import store from '../../store'
import { encodeQueryData } from "@/utils/"

const HourService = {
  list (params) {
    var api_url = window.Urls["v4:timeentry-list"]();
    return customAxios.get(api_url, {params: params});
  },
  listAll (params) {
    var api_url = window.Urls["timeentry-get-hours-with-datetime"]();
    return customAxios.get(api_url, {params: params});
  },
  loadNextPage: function (next_url) {
    return customAxios.get(next_url);
  },
  create (data) {
    var api_url = window.Urls["v4:timeentry-list"]();
    return customAxios.post(api_url, data);
  },
  getTotalAmount (params) {
    var api_url = window.Urls["v4:timeentry-total-amount"]();
    return customAxios.get(api_url, {params: params});
  },
  getTotalAmountV2 (params) {
    var api_url = window.Urls["timeentry-total-amount"]();
    return customAxios.get(api_url, {params: params});
  },
  getTotals (params) {
    var api_url = window.Urls["v4:timeentry-totals"]();
    return customAxios.get(api_url, {params: params});
  },
  destroy (id) {
    var api_url = window.Urls["v4:timeentry-detail"](id);
    return customAxios.delete(api_url);
  },
  destroyWithParams (id, params) {
    var api_url = window.Urls["v4:timeentry-detail"](id);
    return customAxios.delete(api_url, {params: params});
  },
  update (data) {
    var api_url = window.Urls["v4:timeentry-detail"](data.id);
    return customAxios.put(api_url, data);
  },
  count (params) {
    const api_url = window.Urls["timeentry-count"]()
    return customAxios.get(api_url, { params: params })
  },
  hoursPerDay (params) {
    var api_url = window.Urls["v4:timeentry_list_total_hours_per_day"]();
    return customAxios.get(api_url, {params: params}).then( (response) => {
      var day_list = [];
      response.data.forEach( (item) => {
        day_list[item.date] = item;
      })
      return day_list;
    });
  },
  createRecurrentHour(data) {
    var api_url = window.Urls["recurrenttimeentry_list"]();
    return customAxios.post(api_url, data);
  },
  retrieveRecurrentHour(id) {
    var api_url = window.Urls["recurrenttimeentry_detail"](id);
    return customAxios.get(api_url);
  },
  updateRecurrentHour(data) {
    var api_url = window.Urls["recurrenttimeentry_detail"](data.id);
    return customAxios.put(api_url, data);
  },
  getTotalGroupedHours(params) {
    var api_url = window.Urls['v4:timeentry_total_grouped_hours']();
    return customAxios.get(api_url, {params: params});
  },
  activeYears: function (params) {
    var api_url = window.Urls["v4:timeentry_years"]();
    return customAxios.get(api_url, {params: params});
  },
  export_csv(params) {
    var queryString = encodeQueryData(params);
    var api_url = window.Urls["v4:timeentry_export_hours"]() + "?" + queryString;
    return customAxios.get(api_url, { params: params, responseType: 'blob' }).then((response) => {
        return response
    })
  },
  getReportPDFBlob(params){
    var queryString = encodeQueryData(params);
    const api_url = window.Urls['v4:timeentry_export_hours_pdf']() + "?" + queryString
    return customAxios.get(api_url, { params: params, responseType: 'blob' }).then((response) => {
      return response
    })
  },
  getTimezoneList() {
    var api_url = window.Urls["timer_get_timezone_list"]();
    return customAxios.get(api_url);
  },
  getCustomerList(params) {
    var api_url = window.Urls['timeentry-customer-list']();
    return customAxios.get(api_url, { useCache: params?.useCache, params: params })
  },
  markAsInvoiced(data) {
    var api_url = window.Urls['v4:timeentry_mark_as_invoiced']();
    return customAxios.put(api_url, data);
  },
  timeentry2Event (timeentry) {
    const created = new Date(timeentry.date);
    let timeentryClass = 'hour-timeentry'
    timeentryClass += ' ' + ((timeentry.is_invoiced) ? 'timeentry-invoiced' : 'timeentry-uninvoiced')
    timeentryClass += ' ' + ((!timeentry.project) ? 'timeentry-unassigned' : '')

    let recurrent_time_entry = null;
    if (timeentry.recurrent_time_entry && timeentry.recurrent_time_entry.length)
      recurrent_time_entry = timeentry.recurrent_time_entry[0];
    else if (timeentry.recurrent_time_entry && !timeentry.recurrent_time_entry.length)
      recurrent_time_entry = timeentry.recurrent_time_entry;
    
    const event = {
      id: timeentry.id,
      project: timeentry.project,
      description: timeentry.description,
      start: created.format('Y-m-d H:i'),
      invoiced: timeentry.is_invoiced,
      is_invoiced: timeentry.is_invoiced,
      created_by: timeentry.created_by,
      date: timeentry.date,
      amount: timeentry.amount,
      amount_hours: timeentry.amount_hours,
      amount_minutes: timeentry.amount_minutes,
      end: created.addHours(timeentry.amount_hours).addMinutes(timeentry.amount_minutes).format('Y-m-d H:i'),
      recurrent_time_entry: recurrent_time_entry,
      class: timeentryClass,
    };
    return event;
  },
  eventToTimeentry(ev, storedEvent) {
    let event = JSON.parse(JSON.stringify(ev));

    var timeentry = {};
    timeentry.id = event.id;
    timeentry.date = event.start;

    const dateOne = event.start;
    const dateTwo = event.end;
    const dateOneObj = new Date(dateOne);
    const dateTwoObj = new Date(dateTwo);
    const milliseconds = Math.abs(dateTwoObj - dateOneObj);
    const hours = milliseconds / 36e5;
    timeentry.amount = hours.toFixed(2);

    timeentry.description = event.description;
    timeentry.company_profile = store.getters['main/getCompanyId'];
    timeentry.created_by = (event && event.created_by && event.created_by.id) || store.getters['main/getUserId'];
    timeentry.is_invoiced = event.invoiced;

    if((event.project && event.project.id) || storedEvent) {
      timeentry.project = event.project.id || storedEvent
    } else if (!event.project) {
      timeentry.project = null
    }

    return timeentry;
  },
  prepareRecurrentHour(recurrentHour, hour) {
    let data = JSON.parse(JSON.stringify(recurrentHour));

    if (typeof recurrentHour.start_date !== "string")
      data.start_date = recurrentHour.start_date.format('Y-m-d');
    
    switch (recurrentHour.frequency) {
      case "every_day":
        data.interval = "daily";
        data.days = "0,1,2,3,4,5,6";
        break;
      case "every_working_day":
        data.interval = "daily";
        data.days = "0,1,2,3,4";
        break;
      case "every_week":
        data.interval = "weekly";
        data.skip = 1;
        break;
      case "every_month":
        data.interval = "monthly";
        data.skip = 1;
        break;
      default:
        break;
    }

    data.company_profile = store.getters['main/getCompanyId'];

    let hourDate = new Date(hour.date);

    data.template_time_entry = JSON.parse(JSON.stringify(hour));
    data.template_time_entry.start_time = `${hourDate.getHours()}:${hourDate.getMinutes()}`;
    data.template_time_entry.is_invoiced = hour.is_invoiced;
    data.template_time_entry.project = hour.project;
    delete data.template_time_entry.id;
    delete data.template_time_entry.date;
    delete data.time_entries;
    
    return data;
  }
};

export default HourService;